<script>
function formMaxDate() {
  let maxDate = new Date();
  maxDate.setDate(maxDate.getDate() - 6570);
  return new Date(maxDate);
}
function formMinDate() {
  let minDate = new Date();
  minDate.setDate(minDate.getDate() - 36500);
  return new Date(minDate);
}

export default {
  name: 'DatePicker',
  props: {
    placeHolder: {
      type: String,
      required: true
    },
    inputId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    },
    onSelect: {
      type: Function,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    classNames: {
      type: String,
      default: ''
    }
  },
  methods: {
    onInputClick: function() {
      if (typeof this.onSelect === 'function') {
        this.onSelect();
      }
    }
  },
  mounted: function() {
    $('#' + this.inputId).datepicker({
      maxDate: formMaxDate(),
      onSelect: selectedDate => {
        this.$emit('onDateSelected', selectedDate, this.name);
      },
      changeYear: true,
      yearRange: "-100:+18",
    });
  },

  updated: function() {
    if (this.show) {
      $('#' + this.inputId).datepicker('show');
      this.$emit('onDateShow');
    }
  }
};
</script>
<template>
  <input
    readonly
    :show="show"
    autocomplete="off"
    type="text"
    :value="value"
    :placeholder="placeHolder"
    :id="inputId"
    @click="onInputClick"
    :class="'select date-picker has-datepicker ' + classNames"
  />
</template>
<style></style>
